export const Paths = {
  home: { url: "/*" },
  search: { url: "/search" },
  confirmation: { url: "/confirmation" },
  checkout: { url: "/checkout" },
  detailsPage: { url: "/items/*" },
  hardwareSearch: { url: "/hardware" },
  approval: { url: "/order/:orderId/:newStatus" },
  orders: { url: "/orders" },
  lists: { url: "/lists" },
  ordersApproval: { url: "/ordersApproval" },
  whatsNew: { url: "/aiforme/whatsNew" },
  aiformeIntake: { url: "/aiforme/contribute" },
  aiforme: { url: "/aiforme" },
  aiformeMyTools: { url: "/aiforme/mytools" },
  aiForMeLists: { url: "/aiforme/lists" },
  sessionExpired: { url: "/session-expired" },
  notFound: { url: "/*" },
} as const;
